import { IconButton, IconButtonProps } from '@chakra-ui/react'
import { forwardRef } from 'react'
import { FiMenu } from 'react-icons/fi'

export type IDragHandleProps = Omit<IconButtonProps, 'aria-label' | 'icon'> & { label?: string }

/** The grip of a `SortableList` row. Spread `handleProps` from `useSortableRow` into it. */
const DragHandle = forwardRef<HTMLButtonElement, IDragHandleProps>(function DragHandle(
  { label = 'Arrastar para reordenar', ...rest },
  ref
) {
  return (
    <IconButton
      ref={ref}
      aria-label={label}
      title={label}
      // Bundled: a LineIcons name only draws if the CDN's version has it.
      icon={<FiMenu />}
      size="sm"
      variant="ghost"
      colorScheme="gray"
      cursor="grab"
      _active={{ cursor: 'grabbing' }}
      {...rest}
    />
  )
})

export default DragHandle
